import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { TipHeading } from "./TipHeading";
import { TipText } from "./TipText";
export const ThirdTip = (param)=>{
    let { children , headingClassName  } = param;
    return /*#__PURE__*/ _jsxs("article", {
        className: "min-w-[300px]",
        children: [
            children,
            /*#__PURE__*/ _jsx(TipHeading, {
                className: headingClassName,
                children: "Be concise"
            }),
            /*#__PURE__*/ _jsx(TipText, {
                children: "One to 15 minutes should be enough, but if you’ve created something amazing, we’re happy to host longer pieces."
            })
        ]
    });
};
